/* Presentation only: retain the native builder's single purchase control. */
(() => {
  const enhance = root => {
    if (root.dataset.premiumEnhanced) return;
    const action = root.querySelector('[data-checkout]');
    const error = root.querySelector('[data-error]');
    const nav = root.querySelector('.ros-builder__navigation');
    if (!action || !error || !nav) return;
    root.dataset.premiumEnhanced = 'true';
    const actionHome = document.createComment('native builder purchase location');
    const errorHome = document.createComment('native builder error location');
    action.before(actionHome);
    error.before(errorHome);
    const update = () => {
      if (root.dataset.initialized !== 'true') return;
      const reviewing = root.current === 3;
      nav.classList.toggle('rp-builder-review', reviewing);
      if (reviewing) {
        nav.append(action, error);
      } else {
        actionHome.after(action);
        errorHome.after(error);
      }
      // Existing store-wide minimum; total() is the native integer AED amount.
      const total = typeof root.total === 'function' ? root.total() : 0;
      root.querySelectorAll('[data-builder-minimum]').forEach(notice => {
        notice.hidden = !(total > 0 && total < 7900 && (!notice.hasAttribute('data-builder-minimum-final') || reviewing));
      });
    };
    root.addEventListener('bouquet:step', update);
    root.addEventListener('bouquet:change', update);
    update();
  };
  const boot = () => document.querySelectorAll('rdb-custom-bouquet-builder').forEach(enhance);
  customElements.whenDefined('rdb-custom-bouquet-builder').then(boot);
  document.addEventListener('shopify:section:load', boot);
})();
